module.exports = __webpack_public_path__ + "img/1701916427218-image.jpg.ed277225.webp";